module.exports = __webpack_public_path__ + "static/media/employee-recognition.7e4dfbc4.svg";